import React from "react";
import VideoBanner from "../components/HomeSections/VideoBanner";
import AboutUs from "../components/HomeSections/AboutUs";
import VisionMission from "../components/HomeSections/VisionMission";
import Contact from "../components/HomeSections/Contact";
import Products from "../components/HomeSections/Products";

export default function Home() {
    return (
        <div className="home-page">
            <VideoBanner />
            <VisionMission />
            <Products />
            <AboutUs />
            <Contact />
        </div>
    );
}
